<template>
  <b-modal v-model="modalVisible" centered hide-footer title="在庫酒桶簡易報告" size="lg">
    <template #default>
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6 mb-3">
            <div>
              <p class="text-center mb-1">全體<span class="text-danger" v-if="warning">(存在出借異常的酒桶)</span></p>
              <table border="1" class="w-100 text-center">
                <tbody>
                  <tr>
                    <td></td>
                    <td>已清洗</td>
                    <td>未清洗</td>
                  </tr>
      
                  <tr>
                    <td>已填充</td>
                    <td>
                      {{ washedAndFilled }}<br/>
                      <span>在庫: {{ washedAndFilledStocking }}</span><br/>
                      <span>出借: {{ washedAndFilledRented }}</span>
                    </td>
                    <td>{{ notWashedAndFilled }}</td>
                  </tr>
      
                  <tr>
                    <td>未填充</td>
                    <td>{{ washedAndNotFilled }}</td>
                    <td>{{ notWashedAndNotFilled }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <div>
              <p class="text-center mb-1">10L<span class="text-danger" v-if="t10LWarning">(存在出借異常的酒桶)</span></p>
              <table border="1" class="w-100 text-center">
                <tbody>
                  <tr>
                    <td></td>
                    <td>已清洗</td>
                    <td>未清洗</td>
                  </tr>
      
                  <tr>
                    <td>已填充</td>
                    <td>
                      {{ t10LWashedAndFilled }}<br/>
                      <span>在庫: {{ t10LWashedAndFilledStocking }}</span><br/>
                      <span>出借: {{ t10LWashedAndFilledRented }}</span>

                    </td>
                    <td>{{ t10LNotWashedAndFilled }}</td>
                  </tr>
      
                  <tr>
                    <td>未填充</td>
                    <td>{{ t10LWashedAndNotFilled }}</td>
                    <td>{{ t10LNotWashedAndNotFilled }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <div>
              <p class="text-center mb-1">20L<span class="text-danger" v-if="t20LWarning">(存在出借異常的酒桶)</span></p>
              <table border="1" class="w-100 text-center">
                <tbody>
                  <tr>
                    <td></td>
                    <td>已清洗</td>
                    <td>未清洗</td>
                  </tr>
      
                  <tr>
                    <td>已填充</td>
                    <td>
                      {{ t20LWashedAndFilled }}<br/>
                      <span>在庫: {{ t20LWashedAndFilledStocking }}</span><br/>
                      <span>出借: {{ t20LWashedAndFilledRented }}</span>
                    </td>
                    <td>{{ t20LNotWashedAndFilled }}</td>
                  </tr>
      
                  <tr>
                    <td>未填充</td>
                    <td>{{ t20LWashedAndNotFilled }}</td>
                    <td>{{ t20LNotWashedAndNotFilled }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <div>
              <p class="text-center mb-1">30L<span class="text-danger" v-if="t30LWarning">(存在出借異常的酒桶)</span></p>
              <table border="1" class="w-100 text-center">
                <tbody>
                  <tr>
                    <td></td>
                    <td>已清洗</td>
                    <td>未清洗</td>
                  </tr>
      
                  <tr>
                    <td>已填充</td>
                    <td>
                      {{ t30LWashedAndFilled }}<br/>
                      <span>在庫: {{ t30LWashedAndFilledStocking }}</span><br/>
                      <span>出借: {{ t30LWashedAndFilledRented }}</span>
                    </td>
                    <td>{{ t30LNotWashedAndFilled }}</td>
                  </tr>
      
                  <tr>
                    <td>未填充</td>
                    <td>{{ t30LWashedAndNotFilled }}</td>
                    <td>{{ t30LNotWashedAndNotFilled }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'KegMiniDashboardModal',
  data() {
    return {
      washedAndFilled: 0,
      washedAndFilledStocking: 0,
      washedAndFilledRented: 0,
      washedAndNotFilled: 0,
      notWashedAndFilled: 0,
      notWashedAndNotFilled: 0,
      warning: false,

      t10LWashedAndFilled: 0,
      t10LWashedAndFilledStocking: 0,
      t10LWashedAndFilledRented: 0,
      t10LWashedAndNotFilled: 0,
      t10LNotWashedAndFilled: 0,
      t10LNotWashedAndNotFilled: 0,
      t10LWarning: false,

      t20LWashedAndFilled: 0,
      t20LWashedAndFilledStocking: 0,
      t20LWashedAndFilledRented: 0,
      t20LWashedAndNotFilled: 0,
      t20LNotWashedAndFilled: 0,
      t20LNotWashedAndNotFilled: 0,
      t20LWarning: false,

      t30LWashedAndFilled: 0,
      t30LWashedAndFilledStocking: 0,
      t30LWashedAndFilledRented: 0,
      t30LWashedAndNotFilled: 0,
      t30LNotWashedAndFilled: 0,
      t30LNotWashedAndNotFilled: 0,
      t30LWarning: false,
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
  },
  computed: {
    ...mapState('keg', ['kegList']),
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

  },
  watch: {
    modalVisible(val) {
      if (val) {
        this.calculate();
      }
    },
  },
  mounted() {
    this.calculate();
  },
  methods: {
    calculate() {
      this.washedAndFilled = 0;
      this.washedAndNotFilled = 0;
      this.notWashedAndFilled = 0;
      this.notWashedAndNotFilled = 0;

      this.t10LWashedAndFilled = 0;
      this.t10LWashedAndNotFilled = 0;
      this.t10LNotWashedAndFilled = 0;
      this.t10LNotWashedAndNotFilled = 0;

      this.t20LWashedAndFilled = 0;
      this.t20LWashedAndNotFilled = 0;
      this.t20LNotWashedAndFilled = 0;
      this.t20LNotWashedAndNotFilled = 0;

      this.t30LWashedAndFilled = 0;
      this.t30LWashedAndNotFilled = 0;
      this.t30LNotWashedAndFilled = 0;
      this.t30LNotWashedAndNotFilled = 0;

      this.washedAndFilledStocking = 0;
      this.washedAndFilledRented = 0;
      this.t10LWashedAndFilledStocking = 0;
      this.t10LWashedAndFilledRented = 0;
      this.t20LWashedAndFilledStocking = 0;
      this.t20LWashedAndFilledRented = 0;
      this.t30LWashedAndFilledStocking = 0;
      this.t30LWashedAndFilledRented = 0;

      this.warning = false;
      this.t10LWarning = false;
      this.t20LWarning = false;
      this.t30LWarning = false;

      for (const keg of this.kegList) {
        if (keg.status === 0 || keg.status === 1) {
          if (keg.washed) {
            if (keg.filled) {
              this.washedAndFilled += 1;
              if (keg.status === 0) {
                this.washedAndFilledStocking += 1;
              } else if(keg.status === 1) {
                this.washedAndFilledRented += 1;
              }
            } else {
              this.washedAndNotFilled += 1;
              if (keg.status === 1) {
                this.warning = true;
              }
            }
          } else {
            if (keg.filled) {
              this.notWashedAndFilled += 1;
            } else {
              this.notWashedAndNotFilled += 1;
            }
            if (keg.status === 1) {
              this.warning = true;
            }
          }
        }
      }

      const t10L = this.kegList.filter((item) => {
        return item.sizeModel === '10L';
      });

      for (const keg of t10L) {
        if (keg.status === 0 || keg.status === 1) {
          if (keg.washed) {
            if (keg.filled) {
              this.t10LWashedAndFilled += 1;
              if (keg.status === 0) {
                this.t10LWashedAndFilledStocking += 1;
              } else if(keg.status === 1) {
                this.t10LWashedAndFilledRented += 1;
              }
            } else {
              this.t10LWashedAndNotFilled += 1;
              if (keg.status === 1) {
                this.t10LWarning = true;
              }
            }
          } else {
            if (keg.filled) {
              this.t10LNotWashedAndFilled += 1;
            } else {
              this.t10LNotWashedAndNotFilled += 1;
            }
            if (keg.status === 1) {
              this.t10LWarning = true;
            }
          }
        }
      }

      const t20L = this.kegList.filter((item) => {
        return item.sizeModel === '20L';
      });

      for (const keg of t20L) {
        if (keg.status === 0 || keg.status === 1) {
          if (keg.washed) {
            if (keg.filled) {
              this.t20LWashedAndFilled += 1;
              if (keg.status === 0) {
                this.t20LWashedAndFilledStocking += 1;
              } else if(keg.status === 1) {
                this.t20LWashedAndFilledRented += 1;
              }
            } else {
              this.t20LWashedAndNotFilled += 1;
              if (keg.status === 1) {
                this.t20LWarning = true;
              }
            }
          } else {
            if (keg.filled) {
              this.t20LNotWashedAndFilled += 1;
            } else {
              this.t20LNotWashedAndNotFilled += 1;
            }
            if (keg.status === 1) {
              this.t20LWarning = true;
            }
          }
        }
      }

      const t30L = this.kegList.filter((item) => {
        return item.sizeModel === '30L';
      });

      for (const keg of t30L) {
        if (keg.status === 0 || keg.status === 1) {
          if (keg.washed) {
            if (keg.filled) {
              this.t30LWashedAndFilled += 1;
              if (keg.status === 0) {
                this.t30LWashedAndFilledStocking += 1;
              } else if(keg.status === 1) {
                this.t30LWashedAndFilledRented += 1;
              }
            } else {
              this.t30LWashedAndNotFilled += 1;
              if (keg.status === 1) {
                this.t30LWarning = true;
              }
            }
          } else {
            if (keg.filled) {
              this.t30LNotWashedAndFilled += 1;
            } else {
              this.t30LNotWashedAndNotFilled += 1;
            }
            if (keg.status === 1) {
              this.t30LWarning = true;
            }
          }
        }
      }
      
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

</style>
